import React from "react";
import { Box, Column, Columns } from "@origin-digital/ods-core";
import type { PopularCategoriesProps } from "./types";
import { CategoryCard } from "./CategoryCard";

export const PopularCategories: React.FC<PopularCategoriesProps> = ({
  categories,
}) => {
  if (categories.length === 0) {
    return null;
  }

  return (
    <Box data-id="popular-categories" marginX={{ xs: "medium", sm: "none" }}>
      <Columns
        space={{ xs: "medium", lg: "large" }}
        collapseBelow="lg"
        alignY="stretch"
      >
        {categories.map((category) => (
          <Column key={category.id} alignSelf="stretch">
            <CategoryCard category={category} />
          </Column>
        ))}
      </Columns>
    </Box>
  );
};
